import { videoExtensions } from "Constants/constants";
import { usePushBack } from "hooks";
import React, { useState, useEffect } from "react";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import { useHistory, useParams } from "react-router-dom";

function Zoom() {
  const history = useHistory();
  const params = useParams();
  const [images, setImages] = useState([]);

  const closeZoom = () => {
    history.goBack();
  };
  usePushBack(history?.location?.state?.urls, params.domainName);

  useEffect(() => {
    if (history?.location?.state?.urls?.length > 0) {
      setImages(history.location.state.urls);
    } else {
      setImages([]);
    }
  }, [history?.location?.state?.urls]);

  return (
    <div>
      {images?.length >= 1 && (
        <ReactImageVideoLightbox
          data={images?.map(url=>{
            const isVideo = videoExtensions?.some((ext) => url?.endsWith(ext)) ?? false;
            return{
            url:url,
            type:isVideo ? "video" : "photo",
            title: "",
            altTag:""
          }})}
          onCloseCallback={() => closeZoom()}
          startIndex={0}
          showResourceCount={true}
          onNavigationCallback={(currentIndex) =>
            console.log(`Current index: ${currentIndex}`)
          }
        />
      )}
    </div>
  );
}

export default Zoom;
